'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchThreadHistoryClient = undefined;

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchThreadHistoryClient = exports.fetchThreadHistoryClient = function fetchThreadHistoryClient(_ref) {
  var sessionId = _ref.sessionId,
      threadId = _ref.threadId,
      startTime = _ref.startTime;
  return _noAuthApiClient2.default.get('livechat/v1/conversationhistory/visitor/' + threadId, {
    query: {
      sessionId: sessionId,
      offsetTimestamp: startTime,
      portalId: _hubspot2.default.get(),
      sortDirection: 'DESCENDING'
    }
  });
};